import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { VideoPlayer } from "./VideoPlayer";

const cache = new Map();
const TTL = 60_000;

const load = (page, artworkId) => {
  const key = `${page}|${artworkId || ""}`;
  const hit = cache.get(key);
  if (hit && Date.now() - hit.at < TTL) return hit.p;
  const p = api.get("/video-placements", { params: { page, artwork_id: artworkId || undefined } }).then(r => r.data).catch(() => []);
  cache.set(key, { p, at: Date.now() });
  return p;
};

export const useVideoPlacements = (page, spot, artworkId) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let on = true;
    load(page, artworkId).then(all => { if (on) setItems(all.filter(p => p.spot === spot)); });
    return () => { on = false; };
  }, [page, spot, artworkId]);
  return items;
};

export const VideoSlot = ({ page, spot, artworkId, className = "" }) => {
  const items = useVideoPlacements(page, spot, artworkId);
  if (!items.length) return null;
  return (
    <div className={`space-y-10 ${className}`} data-testid={`video-slot-${page}-${spot}`}>
      {items.map(p => <VideoPlayer key={p.id} placement={p} />)}
    </div>
  );
};
